// Module
var code = "<p>תוכלו לכתוב הערות על כל מודעה באמצעות הפתק הצהוב ״הוסף הערות״ שבמודעה. במידה ואתם רשומים לאתר, המידע ישמר ויחכה לכם גם בפעם הבאה שתתחברו.</p> ";
// Exports
export default code;